var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.635 3.217C6.313 3.419 5.8 4.552 5.71 5.093c-.116.297-.44.417-.587.44-.27.01-.845-.086-.846-.721 0-.704.7-1.873 1.853-2.444.658-.327 2.74-.675 4.171.269 1.196.789 1.69 2.207 1.285 3.56-.228.764-1.389 1.82-2.12 2.468s-.877 1.428-.877 1.987c0 .392-.282.454-.66.454h-.006c-.23 0-.68 0-.711-.288-.122-1.108.2-1.916 1.098-2.88.741-.795 2.076-1.554 1.937-2.767-.111-.969-1.072-2.19-2.612-1.954M8.767 13.176a.85.85 0 1 1-1.7 0 .85.85 0 0 1 1.7 0"
  })));
};
export default SvgQuestionMark;